<template>
  <v-card>
    <v-card-text>
      <v-data-table
        :headers="headers_segnalazioni"
        height="75vh"
        :items="items_segnalazioni"
      >
        <template v-slot:top>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Segnalazioni Rilevate
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="clickAggiungiSegnalazione" small>
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="dialog_segnalazioni">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeSegnalazioni"
            :component="'anomalie'"
            :input_args="input_args"
            :key="key_segnalazioni"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "Segnalazioni",
  components: { WindowFrame },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      input_args: {
        clear_on_save: true,
        destinazione: "",
        disegni_iniziali: [],
        id_articolo: 0,
        immagine_standard_editor: "",
        riferimento: 0,
        return_array: true,
        show_close_button: true,
        show_editor_arrow_button: true,
        show_editor_camera_button: true,
        show_editor_circle_button: true,
        show_editor_color_picker_button: true,
        show_editor_crop_button: true,
        show_editor_edit_back_button: true,
        show_editor_edit_forward_button: true,
        show_editor_eraser_button: true,
        show_editor_free_draw_button: true,
        show_editor_large_size_button: true,
        show_editor_letter_case_button: true,
        show_editor_medium_size_button: true,
        show_editor_save_button: true,
        show_editor_small_size_button: true,
        show_editor_square_button: true,
        show_editor_tool_columns: true,
        show_editor_upload_button: true,
        tabella_supporto: "disegno",
        titolo_editor: "Editor",
        visible: true,
      },
      key_segnalazioni: 0,

      // Modal
      dialog_segnalazioni: false,

      // Array
      headers_segnalazioni: [{ text: "Immagine", value: "img", sortable: false }],
      items_segnalazioni: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickAggiungiSegnalazione() {
      this.dialog_segnalazioni = true;
      this.key_segnalazioni = this.key_segnalazioni === 0 ? 1 : 0;
    },
    closeSegnalazioni() {
      this.dialog_segnalazioni = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>